import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type IdentitySectionProps = {
  content: PillarPageContent['identity'];
};
export function IdentitySection({
  content
}: IdentitySectionProps) {
  return <section className="w-full border-y border-accent-deep/40 bg-surface/40 py-28 lg:py-40" data-id="element-141" data-mp="ml8e0y852fd5">
      <div className="mx-auto w-full max-w-[1240px] px-6 sm:px-10" data-id="element-142" data-mp="3m26l7s44q0mo">
        <Reveal data-id="element-143" data-mp="3q1z0eno13510">
          <Eyebrow data-id="element-144" data-mp="3q3igad5rve29">{content.eyebrow}</Eyebrow>
          <h2 className="mt-6 max-w-xl text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3rem]" data-id="element-145" data-mp="3q04d52pab0tr">
            {content.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-0" data-id="element-146" data-mp="3oqpepol6vl4">
          <Reveal data-id="element-147" data-mp="32b1vhuunh7z9">
            <div className="flex h-full flex-col rounded-3xl border border-accent-deep/50 bg-surface p-8 lg:rounded-r-none lg:border-r-0 lg:p-12" data-id="element-148" data-mp="37bpkyc38dgrd">
              <h3 className="text-[11px] font-bold uppercase tracking-label text-ash/60" data-id="element-149" data-mp="16kln4v3wu5lf">Antes</h3>
              <ul className="mt-8 space-y-4" data-id="element-150" data-mp="12k1qrtr5v60c">
                {content.before.map(item => <li key={item} className="flex items-center gap-4 text-base text-ash/60 line-through decoration-accent-deep sm:text-lg" data-id="element-151" data-mp="xr8pxgytchtj">
                    <span className="h-px w-5 bg-ash/25" aria-hidden="true" data-id="element-152" data-mp="nw6zmhssx9pd" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.08} className="flex items-center justify-center lg:px-3" data-id="element-153" data-mp="euh7f9r3i6qj">
            <span className="flex h-12 w-12 items-center justify-center rounded-full border border-accent/30 bg-ink text-accent" data-id="element-154" data-mp="9w5yr2cje29w">
              <ArrowRightIcon className="h-4 w-4 rotate-90 lg:rotate-0" aria-hidden="true" data-id="element-155" data-mp="295vypuzr8e8e" />
            </span>
          </Reveal>

          <Reveal delay={0.14} data-id="element-156" data-mp="2ndqvdh8zyfqp">
            <div className="flex h-full flex-col rounded-3xl border border-accent/25 bg-surface p-8 lg:rounded-l-none lg:border-l-0 lg:p-12" data-id="element-157" data-mp="2ncp7udaso0s3">
              <h3 className="text-[11px] font-bold uppercase tracking-label text-accent" data-id="element-158" data-mp="2s61x8pnasblw">Después</h3>
              <ul className="mt-8 space-y-4" data-id="element-159" data-mp="2eazhzbwk99wf">
                {content.after.map(item => <li key={item} className="flex items-center gap-4 text-base font-semibold text-bone sm:text-lg" data-id="element-160" data-mp="2j9j4bdf2gnpb">
                    <span className="h-px w-5 bg-accent" aria-hidden="true" data-id="element-161" data-mp="3b2jm8zarhxeg" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1} data-id="element-162" data-mp="324hoqtq8lmvx">
          <p className="mx-auto mt-24 max-w-3xl text-center text-xl font-bold leading-snug tracking-[-0.02em] text-bone sm:text-2xl lg:text-3xl" data-id="element-163" data-mp="1loer0cjzyzte">
            {content.statementLead}{' '}
            <span className="text-accent" data-id="element-164" data-mp="1j3p54o5qgkyt">{content.statementAccent}</span>
          </p>
        </Reveal>
      </div>
    </section>;
}